import { useCallback } from 'react';
import { useUpdateDraftSetting } from '../../../settings/store/slice/sectionSettingsActions';
import { QUICK_ACTIONS_SECTION_KEY } from '../../../sections/actions/container/types';
export const useUpdateDraftQuickActions = () => {
  const updateDraftSetting = useUpdateDraftSetting(QUICK_ACTIONS_SECTION_KEY);
  return useCallback(quickActions => {
    updateDraftSetting({
      quickActions
    });
  }, [updateDraftSetting]);
};